<template>
  <el-dialog
    :visible.sync="visibleProxy"
    :title="dialogTitle"
    width="960px"
    append-to-body
    class="baidu-conversation-dialog"
    @close="$emit('close')"
  >
    <baidu-conversation-panel
      :loading="loading"
      :conversation="conversation"
      :highlight-text="highlightText"
    />
  </el-dialog>
</template>

<script>
import BaiduConversationPanel from './BaiduConversationPanel.vue';

export default {
  name: 'BaiduConversationDialog',
  components: {
    BaiduConversationPanel
  },
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    conversation: {
      type: Object,
      default: () => ({})
    },
    highlightText: { type: String, default: '' }
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    clueId() {
      return this.conversation.clueId || '';
    },
    dialogTitle() {
      return '会话详情';
    }
  }
};
</script>
